export default {
    title: 'Seed Letter',

    level: {
        format: 'Level {level}',
        nextLevel: 'Next Level',
        currentLevel: 'Current Level',
    },

    session: {
        count: '{count} times',
        exam: 'Quiz',
        examScore: '{score} points',
        study: 'Study',
        completed: 'Completed',
        locked: 'Locked',
        inProgress: 'In Progress',
    },

    navigation: {
        toWaitingRoom: 'Go to Waiting Room',
        toStudy: 'Study',
        toExam: 'Take Quiz',
        continue: 'Continue',
        stop: 'Stop',
    },

    study: {
        start: 'Start',
        continue: 'Continue',
        complete: 'Complete',
        stop: 'Stop',
        stopConfirm: 'Are you sure you want to stop studying?',
        example: 'Example Sentence',
        meaning: 'Meaning',
        sound: 'Sound',
        listen: 'Listen',
    },

    exam: {
        start: 'Start',
        grade: 'Grade',
        result: 'View Results',
        questions: {
            intro: 'Starting the questions',
            upper: 'Upper Letter Question',
            lower: 'Lower Letter Question',
        },
    },

    modal: {
        studyComplete: {
            title: 'Study Complete',
            message: 'Congratulations! You have completed the study.',
        },
        examComplete: {
            title: 'Quiz Complete',
            message: 'The quiz has been completed.',
        },
        stopConfirm: {
            title: 'Stop Study',
            message: 'Are you sure you want to stop studying?<br/>Your progress may not be saved.',
        },
    },

    errors: {
        audioPlay: 'A problem occurred during audio playback',
        loadData: 'An error occurred while loading data',
    },
};
